/* dusa: Size filter ranges (snippets/dusa-size-buckets.liquid).
   A range checkbox has no name; before Dawn's facets form serializes, copy its
   state onto the hidden exact-size checkboxes it owns. Capture phase, so this
   runs ahead of the form's own input listener. */
(function () {
  'use strict';
  function sync(event) {
    var bucket = event.target;
    if (!bucket || !bucket.hasAttribute || !bucket.hasAttribute('data-dusa-size-bucket')) return;
    var label = bucket.closest('label');
    if (!label) return;
    label.querySelectorAll('[data-dusa-size-member]').forEach(function (member) {
      member.checked = bucket.checked;
    });
  }
  document.addEventListener('input', sync, true);
  document.addEventListener('change', sync, true);
})();
